export function SetTabHeaderBackgroundColour(TabHTMLElement) {
  if (TabHTMLElement != null && TabHTMLElement !== undefined) {
    const Lists = TabHTMLElement.getElementsByTagName('ul');
    if (Lists != null && Lists !== undefined && Lists.length > 0) {
      Lists[0].style.backgroundColor = '#ECFFF3';
    }
  }
}

export function SetViewDropColour(Backdrop) {
  let Continue = true;

  while (Backdrop != null && Backdrop !== undefined && Continue) {
    const HTML: string = Backdrop.innerHTML;
    if (HTML.includes('nb-layout-column')) {
      Backdrop.style.backgroundColor = '#FFFFFF';
      Continue = false;
    } else Backdrop = Backdrop.parentElement;
  }
}

export const FormConstants = {
  NameMaxLength: 50,
  DescriptionMaxLength: 150,
  NotesMaxLength: 500,
};
